    <div class="w-full bg-white p-5">
        <div class="mx-auto max-w-6xl">
            <div class="mb-5 flex md:gap-7">
                <div class="relative">
               
                </div>
                <div class="flex-1">
                    <!-- Badge "Article Public" -->
                    <div class="mb-3">
                        <span class="inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800">
                            <svg class="mr-1 h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
                            </svg>
                            Article Public
                        </span>
                    </div>
                    
                    <h1 class="text-3xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">
                        {{ article?.nom }}
                    </h1>
                    
                    <span class="text-black-500 whitespace-nowrap">
                        {{ ThemeArticle[article?.themeArticle] }}
                    </span>
                    
                    <div *ngIf="article?.image">
                        <app-image
                            [imageClass]="'mt-5 w-full rounded-lg object-cover'"
                            [showIfNotLoaded]="false"
                            [imageSrc]="cloud_front + article?.image"
                        />
                    </div>
                    
                 
                    
                    <div class="my-5 w-full editor-content" [innerHTML]="html"></div>
                    
                    <!-- Section informative pour les articles publics -->
                    <div class="mt-8 rounded-lg bg-gray-50 p-4 border-l-4 border-blue-500">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm text-gray-700">
                                    Cet article est accessible publiquement. Pour accéder à l'ensemble de nos contenus et fonctionnalités, 
                                   connectez-vous
                                    ou créez un compte
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

